<template>
  <v-container class="container-layout">
    <v-layout class="main-layout">
      <div class="previous-page" v-if="$route.name !== 'Login'">
        <span @click="goBack">&lt; 이전 페이지</span>
      </div>
      <div class="logo-layout">
        <v-img class="logo-image" src="@/assets/images/incar_mortgage_260417.png" alt="" />
      </div>
      <v-card class="card-layout">
        <v-card-title class="card-title">
          {{ title }}
        </v-card-title>
        <slot></slot>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "LoginLayout",
  props: ["title"],
  methods: {
    goBack() {
      this.$router.go(-1); // 이전 페이지로 이동
    }
  }
}
</script>

<style lang="scss">
.container-layout {
  padding: 0;
  max-width: 600px;
  .main-layout {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .previous-page {
      width: 100%;
      padding: 20px 0;
      display: flex;
      justify-content: flex-start;
      span {
        font-weight: bold;
      }
      span:hover {
        color: #1772C7;
        cursor: pointer;
      }
    }
    .logo-layout {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      .logo-image {
        width: 150px;
      }
    }
    .card-layout {
      margin: 0 auto;
      width: 350px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      box-shadow: none !important;
      .card-title {
        font-weight: bolder;
        font-size: 2em;
        color: darkblue;
        justify-content: center;
        margin-bottom: 50px;
      }
    }
  }
}
</style>